import { render, staticRenderFns } from "./OffersList.vue?vue&type=template&id=0233ff80&scoped=true&"
import script from "./OffersList.vue?vue&type=script&lang=js&"
export * from "./OffersList.vue?vue&type=script&lang=js&"
import style0 from "./OffersList.vue?vue&type=style&index=0&id=0233ff80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233ff80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpansionPanels,VIcon})
